module.exports = __webpack_public_path__ + "assets/img/about-us.2cb0883c.webp";